<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">動画</div>
    <div class="text-subtitle2">動画のスタイル設定</div>
    <div class="full-width q-pa-sm q-my-xs rounded-borders bg-brand-light text-white">
      ・編集画面では、動画はプレビューできません。
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>動画URL</div>
        <div class="text-caption">url</div>
      </div>
      <MediaInput
        v-model="value.url"
        :mediaType="'video'"
        :maxSize="200"
        :fileFormat="['.mp4']"
        :placeHolder="'https_url_to_video'"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>プレビュー画像</div>
        <div class="text-caption">previewUrl</div>
      </div>
      <MediaInput
        v-model="value.previewUrl"
        :maxSize="1"
        :fileFormat="['.jpeg', '.png', '.jpg']"
        :placeHolder="'https_url_to_preview_image'"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>アスペクト比</div>
        <div class="text-caption">aspectRatio</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.aspectRatio"
        :rules="[(val) => aspectRatioValidate(val) || 'invalid property']"
        placholder="Text"
        class="col"
      />
    </div>
    <q-separator class="q-my-md" v-if="isAdmin" />
    <Action v-model="value.action" v-if="isAdmin" />
  </q-form>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageURIAction, IFlexMessageVideo } from '@/utils/types'
import Action from '@/components/common/flex-message/forms/Action.vue'
import MediaInput from '@/components/common/ui/MediaInput.vue'

@Options({
  components: { MediaInput, Action },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Video extends Vue {
  @Prop()
  modelValue!: IFlexMessageVideo

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageVideo) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: '動画',
        value: 'video',
      },
    ]
  }

  get requiredRule() {
    return {
      linkURI: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.uri'),
      }),
    }
  }

  get validateRule() {
    return {
      linkURI: this.$t('validate.url_validation'),
    }
  }

  urlValidate(val) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    )
    return urlPattern.test(val)
  }

  aspectRatioValidate(val) {
    if (!val) return true

    const match = /^(\d{1,5}(?:\.\d+)?):(\d{1,5}(?:\.\d+)?)$/.exec(val)
    if (!match) return false

    const width = parseFloat(match[1])
    const height = parseFloat(match[2])

    if (width < 1 || width > 100000 || height < 1 || height > 100000) {
      return false
    }

    return height <= width * 3
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
</script>

<style scoped lang="scss">
</style>
